import PencilSvg from "./PencilSvg";
import {
    asLightSvg,
    asDarkSvg,
    asThemedSvg
} from "../../hocs";

const LightPencilSvg = asLightSvg(PencilSvg);
const DarkPencilSvg = asDarkSvg(PencilSvg);
const ThemedPencilSvg = asThemedSvg(PencilSvg);

export default PencilSvg;
export {
    PencilSvg,
    LightPencilSvg,
    DarkPencilSvg,
    ThemedPencilSvg
};
